import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import AppTheme from '../../theme/AppTheme';
import ColorModeSelect from '../../theme/ColorModeSelect';

const BackgroundLayer = styled(Box)({
  position: 'fixed',
  inset: 0,
  backgroundImage: 'url(/loginBg.png)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

const OverlayLayer = styled(Box)({
  position: 'absolute',
  inset: 0,
  background:
    'linear-gradient(180deg, rgba(17, 28, 40, 0.04) 0%, rgba(17, 28, 40, 0.8) 50%, rgba(17, 28, 40, 0.9) 75%, rgb(17, 28, 40) 100%)',
});

const SPLASH_DURATION_MS = 1600;

export default function Splash() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const timerId = window.setTimeout(() => {
      navigate('/signin', { replace: true });
    }, SPLASH_DURATION_MS);
    return () => window.clearTimeout(timerId);
  }, [navigate]);

  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Box sx={{ position: 'relative', minHeight: '100dvh', overflow: 'hidden' }}>
        <BackgroundLayer />
        <OverlayLayer />
        <ColorModeSelect
          sx={{
            position: 'fixed',
            top: '1.5rem',
            right: '1.5rem',
            zIndex: 1,
            color: 'white',
            borderRadius: '40px',
            backgroundColor: 'rgba(255,255,255,0.1)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.18)' },
            '& .MuiOutlinedInput-notchedOutline': { border: '1px solid rgba(255,255,255,0.6)' },
            '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid rgba(255,255,255,0.8)' },
            '& .MuiSelect-select': { color: 'white', py: 1, px: 2 },
            '& .MuiSvgIcon-root': { color: 'white' },
            '&:before, &:after': { display: 'none' },
          }}
        />
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100dvh',
            gap: 1,
          }}
        >
          <Box
            component="img"
            src="/Empirefx_logo_white.png"
            alt="EFX"
            sx={{ height: 56, width: 'auto', objectFit: 'contain' }}
          />
          <Typography
            sx={{
              color: 'white',
              letterSpacing: '0.15em',
              fontSize: '0.8rem',
              fontWeight: 600,
            }}
          >
            SUPPORT PORTAL
          </Typography>
        </Box>
      </Box>
    </AppTheme>
  );
}
